export enum MesEnum {
  Enero = 'Enero',
  Febrero = 'Febrero',
  Marzo = 'Marzo',
  Abril = 'Abril',
  Mayo = 'Mayo',
  Junio = 'Junio',
  Julio = 'Julio',
  Agosto = 'Agosto',
  Septiembre = 'Septiembre',
  Octubre = 'Octubre',
  Noviembre = 'Noviembre',
  Diciembre = 'Diciembre',
}
